import React, { useMemo, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import ActivitiesLayer from "./ActivitiesLayer";
import DateFilter from "./DateFilter";
import Map from "./Map";
import StatesLayer from "./StatesLayer";
import DefaultStatesLayer from "./DefaultStatesLayer";
import { useActivity } from "../hooks";
import { getActivitiesStates } from "../helpers";
import { ActivitySection } from "../ActivitySection";
import { WorkSection } from "../WorkSection";

import classes from "./MapSection.module.scss";

const MapSection: React.FC = () => {
   const [loaded, setLoaded] = useState(false);
   const mapRef = useRef<mapboxgl.Map>();
   const wrapperRef = useRef<HTMLDivElement | null>(null);
   const { activities } = useActivity();

   const activitiesStates = useMemo(
      () => getActivitiesStates(activities),
      [activities]
   );

   const map = loaded ? mapRef.current : null;

   return (
      <div className={classes.mapWrapper} ref={wrapperRef}>
         {map && <DefaultStatesLayer map={map} />}
         {map && <StatesLayer map={map} states={activitiesStates} />}
         {map && <ActivitiesLayer map={map} activities={activities} />}
         <Map mapRef={mapRef} setLoaded={setLoaded} className={classes.map} fullscreenContainer={wrapperRef.current} />
         <div className={classes.statusBar}>
            <div className={classes.statusControl}>
               <DateFilter className={classes.dateFilter}/>               
            </div>
         </div>
         <div className={classes.overlay}>
            <WorkSection />
            <ActivitySection />
         </div>
      </div>
   );
};

export default MapSection;
